



























import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { RootTree } from '@/templates/Tree';
import { Action, Getter, Mutation, State } from 'vuex-class';
import HeaderComponent from './docs-main/header/Header.vue';
import FooterComponent from './docs-main/Footer.vue';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames, StoreActions, StoreMutations } from '@/templates/DataNames';
import LanguageSelector from '@/components/ui/LanguageSelector.vue';
import { currentInstance, debounce, getSelectedLangName } from '@/heplers';
import { computeRootNames } from '@/heplers/searchHelpers';
import ComputeLayoutComponent from '@/components/ComputeLayoutComponent.vue';
import { mobileDetect } from '@/heplers/detectMobile';
import DocsSidebar from '@/components/DocsSidebar.vue';
import { fullContent } from '@/store/profile/actions';

const ArticleRating = () => import('@/components/ui/ArticleRating.vue');
const MobileMenu = () => import('./docs-main/MobileMenu.vue');
const CodeRails = () => import('@/components/docs-main/code-rails-view/CodeRails.vue');
@Component({
  components: {
    DocsSidebar,
    CodeRails,
    LanguageSelector,
    HeaderComponent,
    FooterComponent,
    MobileMenu,
    ComputeLayoutComponent,
    Breadcrumbs,
    ArticleRating,
  },
  metaInfo() {
    return {
      title: (this as any).getTitle as string,
      meta: [
        {
          name: (this as any).getDescription ? 'description' : '',
          content: (this as any).getDescription as string,
        },
        {
          property: (this as any).getDescription ? 'og:description' : '',
          content: (this as any).getDescription as string,
        },
        {
          hid: (this as any).getDescription ? 'description' : '',
          name: (this as any).getDescription ? 'desccription' : '',
          content: (this as any).getDescription as string,
        },
        {
          property: 'og:title',
          content: (this as any).getPageTitle as string,
        },
        {
          property: 'og:image:alt',
          content: (this as any).getPageTitle as string,
        },
      ],
      script: [
        {
          type: (this as any).jsonLd ? 'application/ld+json' : '',
          json: (this as any).jsonLd,
        },
      ],
    };
  },
})
export default class Layout extends Vue {
  @Action(StoreActions.TREE) actionTree: (
    param: Record<string, unknown>
  ) => Promise<(param: Record<string, unknown>) => void>;
  @Action(StoreActions.COUNTRY_CODE) actionCountryCode: () => Promise<
    (param: Record<string, unknown>) => void
  >;
  @Action(StoreActions.CONTENT) actionContent: (
    param: Record<string, unknown>
  ) => Promise<(param: Record<string, unknown>) => void>;
  @Mutation(StoreMutations.BREADCRUMBS) setBreadcrumbs: (url: string) => void;
  @Mutation(StoreMutations.CONTENT) updateContent: (content: any) => void;
  @Mutation(StoreMutations.SET_CONTENT_LOADING) setContentLoading: (status: boolean) => void;
  @Mutation(StoreMutations.TREE) setTree: (tree: any) => void;
  @Mutation(StoreMutations.SET_RENDER_PAGE_STATUS) setRenderPageStatus: (status: boolean) => void;

  @Mutation(StoreMutations.SET_MOBILE_STATE) setMobileVisible: (isMobile: boolean) => void;
  @Mutation(StoreMutations.SET_PROGRESSBAR_STATUS) setProgressBar: (progressBar: boolean) => void;
  @Mutation(StoreMutations.SET_MOBILE_CODE_RAILS) setMobileCodeRails: (bool: boolean) => void;
  @Getter('getTree') treeData: RootTree;
  @Getter('getBreadcrumbs') breadcrumbs: { title: string; url: string }[];
  @Getter('getContent') data: any;
  @Getter pageIncludesCodeExamples: boolean;
  @State selectedLang: string;
  @State toggleListeners: boolean;
  @State contentLoading: boolean;
  @State currentAnchor: string;

  $refs!: {
    layoutColumn: HTMLElement;
    hashLink: HTMLElement[];
    breadcrumb: HTMLElement;
  };

  public isShowMobile = false;
  public loadCodeRails = false;
  private windowHeight: number | 'auto' = null;
  private isOpenMobileMenu = false;
  private loadTree = false;
  private rootNames: any = {};
  private detectMobile = false;
  private breadcrumbHeight: number | 'auto' = 40;
  private emptyMetaPages = ['references', 'search'];
  private debounceHandlerResize = debounce(this.checkMobileResponse, 200);
  private debounceHandlerScroll = debounce(this.removeHashOnTopPage, 200);

  get minHeight(): string {
    if (this.windowHeight && this.windowHeight !== 'auto')
      // 48 - navbar height
      return `${<number>this.windowHeight - 48}px`;
    else return 'auto';
  }

  get getDescription(): string {
    return this.data?.description || null;
  }

  get getTitle(): string {
    let splittedFqdn = this.$route?.meta?.fqdn.split('.') || [];

    let resultTitle = 'Documentation';

    // let spaceSymbol = typeof window === 'undefined' ? ' ' : ' ';
    if (this.emptyMetaPages.includes(this.firstFqdn) && splittedFqdn.length === 1)
      return this.$route.name;
    else {
      // Преобразовываем бредкрамбы в нужный нам title в зависимости от места где находимся
      if (this.firstFqdn === 'references')
        resultTitle = this.breadcrumbs
          .map((obj) => {
            return obj.title === 'References' ? 'API References' : obj.title.replace(/\s/g, ' ');
          })
          .reverse()
          .join(' | ');

      if (['tutorials', 'introduction', 'howtos'].includes(this.firstFqdn)) {
        resultTitle = this.breadcrumbs
          .map((obj, index) => {
            // Заменяем все пробелы на неразрывные
            if (index === 0 || index === this.breadcrumbs.length - 1)
              return obj.title.replace(/\s/g, ' ');
          })
          .filter((elm) => elm)
          .reverse()
          .join(' | ');
      }
    }

    return resultTitle;
  }

  get getPageTitle(): string {
    // let spaceSymbol = typeof window === 'undefined' ? '&nbsp;' : ' ';
    return `${this.getTitle} | ${
      currentInstance === 'kit' ? 'Voximplant Kit | ' : ''
    }Voximplant.com`;
  }

  get currentSdkName() {
    return getSelectedLangName(this.$route.meta.fqdn);
  }

  get hideLanguageTabs() {
    const prohibitedLanguage = ['websdk', 'reactnative', 'voxengine', 'kit', 'fluttersdk'];
    let isMainReference =
      this.$route.meta.fqdn.split('.').length < 3 &&
      this.$route.meta.fqdn.split('.')[0] === 'references';

    return (
      prohibitedLanguage.includes(this.currentSdkName) ||
      this.isSearchPage ||
      this.pageIncludesCodeExamples ||
      isMainReference
    );
  }

  get isSearchPage() {
    return this.$route.name === 'Search';
  }

  get jsonLd() {
    if (this.isSearchPage) return null;

    if (this.jsonLdRootNames)
      if (this.$route.meta.fqdn === 'references') return this.jsonLdRootNames;
      else return [this.jsonLdRootNames, this.jsonLdBreadcrumbs];
    else return this.jsonLdBreadcrumbs;
  }

  get jsonLdRootNames() {
    let splitFqdn = this.$route?.meta?.fqdn?.split('.');

    if (!splitFqdn) return null;

    let resultObj = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: '',
      potentialAction: {
        '@type': 'SearchAction',
        target: '',
        'query-input': 'required name=search_term_string',
      },
    };

    let startUrl =
      currentInstance === 'vox' ? 'https://voximplant.com' : 'https://voximplant.com/kit';

    if (splitFqdn[0] === 'references') {
      resultObj.url = startUrl + this.$route.fullPath;

      if (splitFqdn.length === 1) {
        // Создаем поисковую строку состоящую из всех референсов если мы на странице api reference
        let referenceCats: string = Object.keys(this.rootNames)
          .filter((key) => key.includes('references'))
          .map((key) => 'cats%5B%5D=' + key)
          .join('&');

        resultObj.potentialAction.target = `${startUrl}/docs/search?${referenceCats}&q={search_term_string}`;
      }

      if (splitFqdn.length === 2) {
        resultObj.potentialAction.target = `${startUrl}/docs/search?cats%5B%5D=${this.$route.meta.fqdn}&q={search_term_string}`;
      }

      // Обнуляем таргетное поле, чтобы обнулить обьект позже если не подходит условиям
      if (splitFqdn.length > 2) resultObj.url = '';
    }

    if (['tutorials', 'introduction', 'howtos'].includes(splitFqdn[0]) && splitFqdn.length === 1) {
      resultObj.url = startUrl + this.$route.fullPath;

      resultObj.potentialAction.target = `${startUrl}/docs/search?cats%5B%5D=${this.$route.meta.fqdn}&q={search_term_string}`;
    }

    // Если мы не вошли ни в одно условие, то обнуляем объект
    if (!resultObj.url.length) resultObj = null;

    return resultObj;
  }

  get jsonLdBreadcrumbs() {
    let startUrl =
      currentInstance === 'vox' ? 'https://voximplant.com' : 'https://voximplant.com/kit';

    let resultBreadcrumbs = [
      {
        '@type': 'ListItem',
        position: '1',
        name:
          currentInstance === 'vox' ? 'Voximplant Documentation' : 'Voximplant Kit Documentation',
        item: startUrl + '/docs/',
      },
    ];
    this.breadcrumbs.map((obj, index) => {
      resultBreadcrumbs.push({
        '@type': 'ListItem',
        position: (index + 2).toString(),
        name: obj.title,
        item: startUrl + obj.url,
      });
    });

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: resultBreadcrumbs,
    };
  }

  get firstFqdn() {
    if (this.$route?.meta?.fqdn) return this.$route.meta.fqdn.split('.')[0];
    else return '';
  }

  get isReferencesPage() {
    return currentInstance === 'vox'
      ? this.$route.meta.fqdn === 'references'
      : this.$route.meta.fqdn === 'references' || this.$route.name === 'Voximplant Kit';
  }

  @Watch('$route')
  onRouteChange(newValue: any, oldValue: any) {
    // If we only change hash not reload page
    if (newValue.meta.fqdn !== oldValue.meta.fqdn || this.isSearchPage) this.renderPage(false);
  }

  @Watch('selectedLang')
  onChange() {
    if (Object.keys(fullContent).length) this.updateContent(fullContent);
  }

  @Watch('toggleListeners')
  onToggleListeners(bool: boolean) {
    return bool ? this.addListeners() : this.removeListeners();
  }

  serverPrefetch() {
    // возвращает Promise из действия, поэтому
    // компонент ждёт данные перед рендерингом
    const cookie = this.$ssrContext.req.headers.cookie;
    const queryWithByLink = this.$route.query.with_by_link;

    let cookieWithQuery = cookie;
    if (queryWithByLink && typeof queryWithByLink === 'string') {
      const withByLinkCookie = `with_by_link=${encodeURIComponent(queryWithByLink)}`;
      cookieWithQuery = cookie ? `${cookie}; ${withByLinkCookie}` : withByLinkCookie;
    }
    return this.fetchItem(cookieWithQuery);
  }

  beforeDestroy() {
    GlobalBus.clear.bind(GlobalBus);
    window.removeEventListener('resize', this.checkMobileResponse);
    this.updateContent({});
    this.setBreadcrumbs('');
    this.$refs.layoutColumn.removeEventListener('scroll', this.debounceHandlerScroll);
  }

  async mounted() {
    if (!Object.keys(this.treeData).length) await this.fetchItem();
    const withByLink = this.$route.query.with_by_link;

    if (withByLink) {
      this.$store.commit(StoreMutations.SET_WITH_BY_LINK, true);
    }

    await this.renderPage(true);

    if (!this.isSearchPage) this.setBreadcrumbs(this.$route.meta.fqdn);

    this.$nextTick(() => {
      this.initUIMethods();
    });
  }

  private initUIMethods(): void {
    GlobalBus.on(GlobalBusNames.TOGGLEMOBILE, (value: boolean) => (this.isOpenMobileMenu = value));
    setTimeout(() => {
      this.computeHashLinks();
    }, 0);

    this.checkMobileResponse(false);
  }

  private addListeners() {
    this.$refs.layoutColumn.addEventListener('scroll', this.debounceHandlerScroll, {
      passive: true,
    });
    window.addEventListener('resize', this.debounceHandlerResize, { passive: true });
  }

  private computeHashLinks() {
    if (typeof window === 'undefined') return;

    document.querySelectorAll('a').forEach((link: any) => {
      if (link?.dataset?.legend) return;

      if (link.pathname !== window.location.pathname) return;

      if (!link.classList.length && link?.hash.length) {
        link.setAttribute('ref', 'hashLink');
        link.addEventListener('click', (_event: any) => {
          GlobalBus.emit(
            GlobalBusNames.LEGENDOPTIONSSCROLL,
            `anything.${link.hash.replace('#', '')}`
          );
        });
      }
    });
  }

  private removeListeners() {
    this.$refs.layoutColumn.removeEventListener('scroll', this.debounceHandlerScroll);
    window.removeEventListener('resize', this.debounceHandlerResize);
  }

  private checkMobileResponse(fromResize: any) {
    this.windowHeight = window.innerHeight;
    this.breadcrumbHeight = this.$refs.breadcrumb?.offsetHeight || 40;
    this.isShowMobile = document.body.clientWidth < 1024;
    this.setMobileCodeRails(document.body.clientWidth < 1280);
    this.setMobileVisible(this.isShowMobile);
    if (!fromResize) this.addListeners();
  }

  private removeHashOnTopPage() {
    if (this.$refs.layoutColumn?.scrollTop === 0)
      window.history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search
      );

    this.$nextTick(this.checkFirstAnchor);
  }

  private checkFirstAnchor() {
    let scrollTop = this.$refs?.layoutColumn?.scrollTop;
    if (scrollTop > 0 && scrollTop < 600) {
      if (typeof window.history.replaceState == 'function' && this.currentAnchor.length) {
        window.history.replaceState('', document.title, '#' + this.currentAnchor);
      }
    }
  }

  private async getTreeData(cookie?: string) {
    await this.actionCountryCode();
    await this.actionTree({ anchors: 0, cookie })
      .then(() => (this.loadTree = true))
      .catch((error) => error);
  }

  private async getContentData(cookie?: string) {
    const url = this.$route?.meta?.fqdn || '';
    const splittedUrl = url.split('.');

    if (splittedUrl.length === 2 && splittedUrl[0] === 'references') this.$route.query.depth = '2';

    if (this.isReferencesPage) {
      this.updateContent(fullContent);
      return;
    }

    if (!url.length) return;

    if (typeof window !== 'undefined') {
      const dataFromLanding = localStorage.getItem('fromLanding');

      if (url === this.data?.fqdn && dataFromLanding) {
        localStorage.removeItem('fromLanding');
        return;
      }
    }

    await this.actionContent({ fqdn: url, cookie, ...this.$route.query }).catch((error) => error);
  }

  private getRootNames() {
    this.rootNames = computeRootNames(this.treeData);

    this.$store.commit(StoreMutations.ROOT_NAMES, this.rootNames);
  }

  private initLoadingPage(layoutRef: HTMLElement) {
    this.setRenderPageStatus(false);
    this.setProgressBar(true);

    layoutRef.style.opacity = '0';
    if (!this.$route.hash && this.$route.name !== 'Search' && layoutRef)
      //@ts-expect-error: Type '"instant"' is not assignable to type 'ScrollBehavior'
      layoutRef.scrollTo({ top: 0, behavior: 'instant' });
  }

  private async loadPageContent(layoutRef: HTMLElement, fromMount: boolean) {
    const url = this.$route.meta.fqdn;

    if (!fromMount) await this.getContentData();

    await this.setBreadcrumbs(url);
    await this.finishRenderPage(layoutRef);
  }

  private finishRenderPage(layoutRef: HTMLElement) {
    layoutRef.style.opacity = '1';
    this.setRenderPageStatus(true);
    this.setProgressBar(false);
    this.loadCodeRails = true;
  }

  private async fetchItem(cookie?: string) {
    await this.getTreeData(cookie);
    await this.getContentData(cookie);
    await this.setBreadcrumbs(this.$route.meta.fqdn);
    await this.getRootNames();
  }

  private renderPage(fromMount: boolean) {
    this.detectMobile = mobileDetect();
    let layoutRef = this.$refs.layoutColumn;

    if (!fromMount) this.initLoadingPage(layoutRef);

    if (this.isSearchPage) {
      GlobalBus.emit(GlobalBusNames.RENDERSEARCH);
      this.finishRenderPage(layoutRef);
      return;
    }

    this.loadPageContent(layoutRef, fromMount);
  }
}
